require("!!/Users/aknobloch/Workspaces/dashing/node_modules/script-loader/addScript.js")(require("!!/Users/aknobloch/Workspaces/dashing/node_modules/raw-loader/index.js!/Users/aknobloch/Workspaces/dashing/bower_components/underscore/underscore.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./bower_components/underscore/underscore.js
// module id = 2
// module chunks = 0